import React from 'react';
import {Separator} from '@spaced-out/ui-design-system/lib/components/Separator';

import css from './helper-components.css';


export const SeparatorWrapper = () => {
  return (
    <div className={css.separatorWrapper}>
      <Separator
        width="1px"
        height="20px"
        orientation="vertical"
        testId="separator-story"
      />
    </div>
  );
};
